import React, { Suspense } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { 
	createBrowserRouter,RouterProvider, 
	//BrowserRouter, Route, Routes, 
	Navigate,
} from 'react-router-dom'
import { 
} from '@coreui/react';
import { ErrorBoundary } from 'react-error-boundary';
import './assets/scss/style.scss'
import CIcon from '@coreui/icons-react'
import { UFunc } from './helpers/functions'
import useToken from './helpers/useToken'
import staticRoutes from './helpers/staticRoutes';
import { isMobile } from "react-device-detect";
import { 
	MyLoader,
	MyToaster,
	MyDialogsession,
} from './components/index'

//--PAGES--/
import { 
	Login,
	Error500,
	Updatedlogs,
	Layout
} from "./pages/index"
//--END PAGES--/

//---CONTAINERS--/
//const Layout = React.lazy(() => import('./pages/Layout'))
//---END CONTAINERS--*/

const pjson	= require('../package.json');
const App 	= (props) => {
	const { token, setToken } 			= useToken();
	const uDispatch    					= useDispatch();

	const uToastlistArr					= useSelector(state => state.listToast) || [];
	const uRouteProfileArr				= useSelector(state => state.profileRoute); 
	const uRoutesloadArr 				= JSON.parse(localStorage.getItem("routeslist") || "[]");
	const [uRoutescontentArr,setRoutescontentArr]		= React.useState(uRoutesloadArr);
	const uActiveRoute  				= useSelector(state => state.activeRoute);
	const uSystemsettingObj				= useSelector(state => state.gSystemsetting);
	const uEfekapp						= useSelector(state => state.effectApp);
	const uEfeksessionapp				= useSelector(state => state.effectsessionApp) || false;
	const uRouteISrefresh				= useSelector(state => state.gRouteISrefresh) || false;
	const uErrorlokasimsg				= useSelector(state => state.locationError);

	const [uIsTotopshow,setTotopshow]	= React.useState(false);
	const [uBahasaObj,setBahasaob]		= React.useState({});
	const [isApploading,setApploading]	= React.useState(false);
	const [isLoading, setLoading]      	= React.useState(false);
	const [isInitKoneksi, setInitKoneksi ]= React.useState(true);
	const [uLayoutchildrenArr,setLayoutchildrenArr]= React.useState([]);
	const [uPagerouteactiveArr,setPagerouteactiveArr]	= React.useState([]);
	const uGeolocationStr				= useSelector(state => state.geolocation_str);
	
	const [uToasteraddObj,setToasteraddObj]	= React.useState();
	//let uBrowserrouterArr;

	//--TIMEOUTSESSION--/
	const uTimeouttimer					= parseInt(uSystemsettingObj.limit_session) || 900;
	const [uISSessionaktif,setSessionaktif]		= React.useState(false);
	const [uCoundownsession,setCoundownsession]	= React.useState(uTimeouttimer);

	const [uSessionTimeStart,setSessionTimeStart]= React.useState();
	//--END TIMEOUTSESSION--/

	//--DLG_FORM--/
	const [uISSessionalreadywarn,setSessionalreadywarn]  	= React.useState(false);
	const [uIsDlgsessionshow,setDlgsessionshow]	= React.useState(false)
	const [uKlikDlgsessionYA,setKlikDlgsessionYA]= React.useState(false)
	//--END DLG_FORM--/

	/*const uDefaultrouter	= [
		{path:"*", element:(<Navigate to="/"/>) },
	];
	const [uBrowserrouterArr,setBrowserrouterArr]= React.useState(uDefaultrouter);//-*/

	//---DETIL_PAGE--/
	const uDetilPageArr 	= [
		{path:"/user/rolesetting/:id",name:"userrole",owner:"user",},
		{path:"/user/logvisit",name:"uservisit",owner:"user",},
		{path:"/subkeuangan/kastransfer/forminput", name:"kastransferform",owner:"kastransfer",},
		{path:"/subkeuangan/kasselisih/forminput", name:"kasselisihform",owner:"kasselisih",},
		{path:"/subkeuangan/ruparupa/forminput",name:"ruparupaform",owner:"ruparupa",},
		{path:"/subkeuangan/omzetlain/forminput", name:"omzetlainform",owner:"omzetlain",},
		{path:"/subkeuangan/biaya/forminput", name:"biayaform",owner:"biaya",},
		
		{path:"/subpurchase/requestorder/inputorder/:id", name:"requestorderinput",owner:"requestorder",},
		{path:"/subpurchase/requestorder/barangdatang/:id", name:"requestorderapprove",owner:"requestorder",},
		{path:"/subpurchase/returbeli/forminput/",name:"returbeliform",owner:"returbeli",},
		{path:"/subkeuangan/belibarang/formmain/:id", name:"belibarangmain",owner:"belibarang",},
		{path:"/subkeuangan/konsinyasi/formmain", name:"konsinyasimain",owner:"konsinyasi",},
		{path:"/subkeuangan/beliaset/formmain", name:"beliasetmain",owner:"beliaset",},
		
		{path:"/subkeuangan/kasbon/forminput", name:"kasbontambah",owner:"kasbon",},
		{path:"/subkeuangan/kasbon/listdata", name:"kasbonpreview",owner:"kasbon",},
		
		{path:"/subkeuangan/hsupplier/listdata",name:"hutangsupplierpreview",owner:"hutangsupplier",},
		{path:"/subkeuangan/hbeliaset/listdata",name:"hutangbeliasetpreview",owner:"hutangbeliaset",},
		{path:"/subkeuangan/hutangjpl/listdata",name:"hutangjplpreview",owner:"hutangjpl",},
		{path:"/subkeuangan/hutanglain/forminput",name:"hutanglaintambah",owner:"hutanglain",},
		{path:"/subkeuangan/hutanglain/listdata",name:"hutanglainpreview",owner:"hutanglain",},
		{path:"/subkeuangan/hutangpsaham/forminput",name:"hutangpsahamtambah",owner:"hutangpsaham",},
		{path:"/subkeuangan/hutangpsaham/formbayar",name:"hutangpsahambayar",owner:"hutangpsaham",},
		{path:"/subkeuangan/hutangpsaham/listdata",name:"hutangpsahampreview",owner:"hutangpsaham",},
		{path:"/subhutang/tagihanpajak/inputdata",name:"tagihanpajakinput",owner:"tagihanpajak",},
		{path:"/subhutang/tagihanpajak/listdata",name:"tagihanpajakpreview",owner:"tagihanpajak",},
		{path:"/substok/stokopname/formproses/:barang_id",name:"stokopnameset",owner:"stokopname",},
		{path:"/substok/pecahstok/forminput",name:"pecahstoktambah",owner:"pecahstok",},
		{path:"/substok/pakaiklinik/forminput",name:"pakaikliniktambah",owner:"pakaiklinik",},
		{path:"/substok/baranged/forminput",name:"barangedtambah",owner:"baranged",},
		{path:"/subkaryawan/payroll/formpayroll/:id",name:"payrollform",owner:"payroll",},
		{path:"/kasir/kasirtoko/forminput",name:"kasirtokomain",owner:"kasirtoko",},
		{path:"/kasir/kasirtoko/forminput",name:"kasirtokomain",owner:"copynota",},
		{path:"/kasir/titipandp/forminput/:id_customer",name:"titipandpmain",owner:"titipandp",},
		{path:"/kasir/titipandp/formrefund/:id",name:"titipandprefund",owner:"titipandp",},
		{path:"/klinik/pasien/forminput/:id",name:"pasieninput",owner:"pasien",},
		{path:"/klinik/pasien/rekammedis/:id",name:"pasienrekammedis",owner:"pasien",},
		{path:"/klinik/pasien/detilrekmed/:id_rm",name:"pasienrmdetil",owner:"pasien",},
		{path:"/klinik/pasien/formbooking/",name:"pasienbooking",owner:"jadwal",},
		{path:"/klinik/pasien/rekammedis/:id",name:"pasienrekammedis",owner:"jadwal",},
		{path:"/klinik/pasien/detilrekmed/:id_rm",name:"pasienrmdetil",owner:"jadwal",},
		{path:"/klinik/pasien/forminput/:id",name:"pasieninput",owner:"jadwal",},
		{path:"/klinik/pasien/formtreatment/:id",name:"ongoingitem",owner:"ongoing",},
		{path:"/klinik/pasien/rekammedis/:id",name:"pasienrekammedis",owner:"ongoing",},
		{path:"/klinik/pasien/detilrekmed/:id_rm",name:"pasienrmdetil",owner:"ongoing",},
		{path:"/klinik/pasien/forminput/:id",name:"pasieninput",owner:"ongoing",},
		{path:"/kasir/kasirklinik/formbayar/:customer_id",name:"kasirklinikmain",owner:"kasirklinik",},
		{path:"/subhutang/hutangkonsi/listdata",name:"hutangkonsipreview",owner:"hutangkonsi",},
	]
	//---END DETIL_PAGE--/

	//---HANDEL--/
	const hdlKlikToTop	= () => { window.scrollTo({ top: 0, behavior: "smooth" }); };
	const hdlKDownField	= (_EV) => {
		if (_EV.keyCode === 13 && (_EV.target.nodeName === "INPUT"
			|| _EV.target.nodeName === "SELECT"
			|| _EV.target.nodeName === "TEXTAREA")
		){
			if (_EV.target.nodeName === "TEXTAREA") {
				if(isMobile) return;
				if(_EV.shiftKey) return;
			}

			var form      = _EV.target.form;
			/*console.log("("+uComponentname+") addEventListener => form 1 "+form);
			if(isNaN(form)) {
				console.log("("+uComponentname+") addEventListener => form 1a "+form);
			}//-*/
			if(UFunc.isEmpty(form)) return;
			//console.log("("+uComponentname+") addEventListener => form 2 "+form);
			var index     = Array.prototype.indexOf.call(form, _EV.target);
			var vJmlLoop  = 0;
			var vFocusedBl= false;
			do{
				index++;
				vJmlLoop++;
				var vElement  = form.elements[index];
				if(vElement && !vElement.disabled 
					&& vElement.style.visibility !== "hidden"
					&& vElement.style.display !== "none"
				) {
					vFocusedBl = true;
					vElement.focus();
				}
				/*console.log("("+uComponentname+") addEventListener => ID "+(vElement.id && vElement.id));
				console.log("("+uComponentname+") addEventListener => visibility : "+(vElement.style.visibility));
				console.log("("+uComponentname+") addEventListener => display : "+(vElement.style.display));//-*/
			} while(!vFocusedBl && vJmlLoop <= 5)
			_EV.preventDefault();
		}
	}
	const hdlToggleDlgsession = () => { setDlgsessionshow(false)}
	const hdlKlikDlgsessionYA = () => {
		setKlikDlgsessionYA(true);
		//apiProsessession(); 
	}
	const hdlScroll = () => {
		if (window.pageYOffset > 300) setTotopshow(true);
		else setTotopshow(false);
	}
	const hdlScrollWindow=(e)=>{
        /*const windowHeight 	= "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body 			= document.body;
        const html			= document.documentElement;
        const docHeight 	= Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom 	= windowHeight + window.pageYOffset;
        if (windowBottom >= docHeight-5) {
			uDispatch({type: "set", gIsScrollBottom: true});
		} else {
			uDispatch({type: "set", gIsScrollBottom: false});
		}//-*/
	}
	//---END HANDEL--/

	//---GLOBAL_PROP_FUNCTION--/
	const showToast  = (_PESAN, _TIPE = "INFO") => {
		const vFilteredArr = uToastlistArr.filter(vItems=>vItems.teksIsi === _PESAN);
		if(vFilteredArr.length > 0) {
			//console.log("(App - showToast) _PESAN: ",_PESAN);
			return;
		}

		const vTmps  	= { id: Date.now() + 1, type : _TIPE, teksIsi : _PESAN };
		//console.log("(App - showToast) vTmps : ",JSON.stringify(vTmps));
		setToasteraddObj(vTmps); 
	}
	const clearStorage = () => {
		const vGeolocationObj = JSON.parse(uGeolocationStr||"{}");
		localStorage.removeItem("routeslist");
		localStorage.removeItem("listkeyword");
		
		setSessionaktif(false);
		//console.log("(App - clearStorage) vGeolocationObj",vGeolocationObj);
		vGeolocationObj.watchID && (navigator.geolocation.clearWatch(vGeolocationObj.watchID));

		uDispatch({type: "set", gUrlbefore: ""});
		uDispatch({type: "set", gInitTabelSelected: {}});
		setLayoutchildrenArr([]);
		setDlgsessionshow(false);
		uDispatch({type: "set", geolocation_str: undefined});
	}
	const prosesExpired = () => {
		clearStorage();

		showToast(uBahasaObj.pesan_hasexpired || pjson.mydefault.msgExpired);
		setToken("");
		setLoading(false);
	}
	const prosesSessioncount = () => {
		if(!uSessionTimeStart) return;
		//if(uSessionTimeStart === undefined) return;

		const vTimecekDT	= new Date();
		const vSelisihDTK	= parseInt((vTimecekDT.getTime() - uSessionTimeStart.getTime()) / 1000 );
		
		//console.log("(App - prosesSessioncount) vSelisihDTK => "+vSelisihDTK);
		let vCountsession	= uTimeouttimer - vSelisihDTK; 
		if(vCountsession === uCoundownsession) vCountsession++;
		
		setCoundownsession(vCountsession);
		//console.log("(App - prosesSessioncount) uTimeouttimer => "+uTimeouttimer);
	}
	const initDashboard = () =>{
		/*//--
		1. Hapus Dashboard 6 bulan
		2. JIKA Tgl Satu Bulan Baru KOSONG,Tanggal BLN Kemarin Dihapus
		3. Cek setiap 3 jam, jika sudah tiga jam, Tanggal BLN Ini Dihapus.//-->Ini dilakukan di DASHBOARD
		//-*/
	
		const vDatadashboardObj	= JSON.parse(localStorage.getItem("dashboard_data") || "{}");
		const vTimestampTS		= vDatadashboardObj.timestampTS;
		if(!vTimestampTS) return;

		const vTglnowDT 		= new Date();
		const vDataArr			= vDatadashboardObj.data_arr || [];
		const vTglsatuDT		= new Date(vTglnowDT.getFullYear(),vTglnowDT.getMonth(),1);

		let vTgl6monthDT		= new Date();
		new Date(vTgl6monthDT.setMonth(vTgl6monthDT.getMonth() - 7));
		
		let vTglLastmonthDT 	= new Date();
		new Date(vTglLastmonthDT.setMonth(vTglLastmonthDT.getMonth() - 1));
		const vTgl1LastmonthDT	= new Date(vTglLastmonthDT.getFullYear(),vTglLastmonthDT.getMonth(),1);
		
		const vTglsatuTS		= vTglsatuDT.valueOf();
		const vTgl6monthTS		= vTgl6monthDT.valueOf();
		const vTgl1LastmonthTS	= vTgl1LastmonthDT.valueOf();

		/*console.log("(App - initDashboard) vTglnowDT => "+vTglnowDT);
		console.log("(App - initDashboard) vTgl6monthDT => "+vTgl6monthDT);
		console.log("(App - initDashboard) vTgl1LastmonthDT => "+vTgl1LastmonthDT);//-*/

		//--HAPUS_DATA_LEWAT_6_BULAN--/
		let vFilteredArr		= vDataArr.filter((vItems,vKeys) => {
			const vTglfilterTS	= UFunc.toDate(vItems.tgl_filter).valueOf();
			return (vTglfilterTS > vTgl6monthTS);
		})
		//--END HAPUS_DATA_LEWAT_6_BULAN--/

		const vDatanowArr = vFilteredArr.filter(vItems => {
			const vTglfilterTS 	= UFunc.toDate(vItems.tgl_filter).valueOf();
			return vTglfilterTS === vTglsatuTS;
		})

		//--JIKA_BULAN_INI_MASIH_KOSONG_HAPUS_BULAN_LALU--/
		if(vDatanowArr.length <= 0) {
			vFilteredArr = vFilteredArr.filter((vItems,vKeys) => {
				const vTglfilterTS	= UFunc.toDate(vItems.tgl_filter).valueOf();
				return (vTglfilterTS !== vTgl1LastmonthTS);
			})
		}
		//--END JIKA_BULAN_INI_MASIH_KOSONG_HAPUS_BULAN_LALU--/

		vDatadashboardObj.data_arr 		= vFilteredArr;
		localStorage.setItem("dashboard_data",JSON.stringify(vDatadashboardObj));
	}
	//---END GLOBAL_PROP_FUNCTION--/

	//--CONTENT--/
	const ContentSpinner = () => {
		return (
		<div className="position-fixed w-100 h-50 d-flex justify-content-center align-items-center"
			style={{zIndex:1091}}>
			<small className="text-muted fst-italic">Waiting..</small>
		</div>
		)//>
	}
	//--END CONTENT--/

	//---REST_API--/
	const apiLoadinit = () => {
		setApploading(true);
		setInitKoneksi(true);
		setSessionaktif(false);

		/*//---TEST_FRONTEND--/
		let vTimeout	= setTimeout(function(){
			setApploading(false);
			//setInitKoneksi(false);
			//setToken("")
		},2000); return;
		//---END TEST_FRONTEND--*/

		const vDATAS= JSON.stringify({ 
			send_tokenauth:token, 
			x:"x" 
		});
		const vURLs	= pjson.homepage+"api2/api_init/ld_init";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST", mode: "cors",
			cache: "default", body: vDATAS,
		}).then((response)=> { if (response.status === 200) return response.json();
		}).then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setApploading(false);
			setBahasaob(JSON.parse(output_string.langs||"[]"));
			uDispatch({type: "set", gSystemsetting:JSON.parse(output_string.systemsetting||"{}")});
			localStorage.setItem("layananlist", (output_string.layananlist||"[]")); 
			//console.log("(App - apiLoadinit) output_string.systemsetting : "+(output_string.systemsetting));

			if(output_string.tampil) {
				if(token) {
					uDispatch({type: "set", listNav: JSON.parse(output_string.nav || "[]")});
					uDispatch({type: "set", gIsEOMExecuted: ((output_string.status_eom||"TIDAK")==="YA")});
					uDispatch({type: "set", gEOMLabel: (output_string.status_eom_label||"") });
					//uDispatch({type: "set", gIsEOMExecuted: true});//--TESTING--/
					
					//console.log("(App - apiLoadinit) output_string.nav : "+output_string.nav);
					if(output_string.routes) {
						const vRouteLoadArr = JSON.parse(output_string.routes||"[]");
						const vNewRoutes	= [...uRouteProfileArr,...vRouteLoadArr];
						localStorage.setItem("routeslist", JSON.stringify(vNewRoutes)); 
						uDispatch({type: "set", gRouteISrefresh: true});
					}

					if(vTimeDiff > 500) setSessionaktif(true);
					else {
						let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
					}
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(App - apiLoadinit) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;

				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				if(token) { 
					prosesExpired();
				}
			}
		}).catch((error) =>{
			setInitKoneksi(false);
			setApploading(false);
			console.log("(App - apiLoadinit) catch-error : "+error);
		});
	}
	const apiProsessession = () => {
		const vEldisabled = document.getElementById("btnDlgsessionYa")
		vEldisabled && (vEldisabled.disabled=true);
		setLoading(true)

		const vDATAS	= JSON.stringify({ send_tokenauth:token });
		const vURLs		= pjson.homepage+"api2/api_init/pr_session";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			vEldisabled && (vEldisabled.disabled=false);
			setLoading(false);
			//console.log("(App - apiProsessession) output_string => ",(output_string));
			if(output_string.sukses) {
				//console.log("output_string => "+output_string.sukses);
				setSessionaktif(true);
				hdlToggleDlgsession();
			} else if(output_string.expired) {
				if(token) { 
					showToast(uBahasaObj.pesan_hasexpired || pjson.mydefault.msgExpired);
					setToken(""); 
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(App - apiProsessession) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			}
		})
		.catch((error) =>{
			vEldisabled && (vEldisabled.disabled=false);
			setLoading(false);
			console.log("(App - apiProsessession) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseslokasi = () => {
		setLoading(true);

		const vDATAS	= JSON.stringify({ 
			send_tokenauth: token, 
			send_geolocation: uGeolocationStr||"" 
		});
		const vURLs	= pjson.homepage+"api2/api_init/pr_geolocation";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
			} else if(output_string.expired) {
				if(token) { 
					showToast(uBahasaObj.pesan_hasexpired || pjson.mydefault.msgExpired);
					setToken(""); 
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(App - apiProseslokasi) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(App - apiProseslokasi) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(() => {
		document.addEventListener("keydown", hdlKDownField);
		window.addEventListener("keydown", hdlKDownField);
		document.addEventListener("scroll", hdlScroll);
		window.addEventListener("scroll", hdlScrollWindow);

		//return function cleanup() {
		return () => {
			window.removeEventListener("scroll", hdlScrollWindow);
			window.removeEventListener("keydown",hdlKDownField);
			document.removeEventListener("keydown",hdlKDownField);
			document.removeEventListener("scroll",hdlScroll);
		}
	});
	React.useEffect(() => {
		/*//---LOAD_BAHASA--//->LAMA
		apiLoadinit();
		//---END LOAD_BAHASA--*/

		if(token) {
			let vErrortmp;
			if (navigator.geolocation) {
				if(token) setLoading(true); else setApploading(true);
				navigator.geolocation.getCurrentPosition((position) => {
					setApploading(false);
					setLoading(false);
					const watchID = navigator.geolocation.watchPosition(()=>{}, ()=>{});
					const vTmpObj = {
						latitude: position.coords.latitude,
						longitude: position.coords.longitude, 
						watchID: watchID, 
					}
					uDispatch({type: "set", geolocation_str: JSON.stringify(vTmpObj)});
					apiLoadinit();
				},
				// Error callback: sets an error message based on the error code
				(err) => {
					setApploading(false);
					setLoading(false);

					switch (err.code) {
						case err.PERMISSION_DENIED:
							vErrortmp = ("User denied the request for Geolocation.");
							break;
						case err.POSITION_UNAVAILABLE:
							vErrortmp = ("Location information is unavailable.");
							break;
						case err.TIMEOUT:
							vErrortmp = ("The request to get user location timed out.");
							break;
						case err.UNKNOWN_ERROR:
							vErrortmp = ("An unknown error occurred.");
							break;
						default:
							vErrortmp = ("An unexpected error occurred.");
					}
					// Log the error message for better debugging, or the error object if message is not available
					console.error("Geolocation Error:", err.message || err);
					console.log("(App - []) Geolocation Error:", vErrortmp);
					uDispatch({type: "set", locationError: "NOTE Lokasi: "+vErrortmp});

					apiLoadinit();
				},
				// Options for getCurrentPosition
				{
					enableHighAccuracy: true, // Request the most accurate position possible
					timeout: 5000,            // Maximum time (ms) to wait for a position
					maximumAge: 0             // Don't use a cached position
				});
			} else {
				// Browser does not support Geolocation
				uDispatch({type: "set", geolocation_str: undefined});
				//localStorage.removeItem("geolocation_str");
				vErrortmp	= ("NOTE Lokasi: Geolocation is not supported by your browser.");
				uDispatch({type: "set", locationError: vErrortmp});

				//---LOAD_BAHASA--/
				apiLoadinit();
				//---END LOAD_BAHASA--/
			}
		} else {
			apiLoadinit();
		}

		//--INIT_DASHBOARD--/
		initDashboard();
		//--END INIT_DASHBOARD--/

		return ()=>{ 
			setBahasaob([]); setSessionaktif(false); setDlgsessionshow(false);
			setPagerouteactiveArr([]); setLayoutchildrenArr(uRoutescontentArr);
			//setBrowserrouterArr(uDefaultrouter);
			uDispatch({type: "set", geolocation_str: undefined});
			uDispatch({type: "set", listToast: undefined});
		}
	},[]);
	React.useEffect(() => { uDispatch({type: "set", listBahasa: uBahasaObj}); },[uBahasaObj]);
	React.useEffect(() => { window.scrollTo({top: 0}); },[uEfekapp]);
	React.useEffect(() => { if(!token) clearStorage(); },[token]);
	React.useEffect(() => {
		//console.log("(App - [uISSessionaktif]) uISSessionaktif",uISSessionaktif);
		uDispatch({type: "set", effectsessionApp: uISSessionaktif});

		if(!uISSessionaktif) {
			setDlgsessionshow(false);
			setCoundownsession(uTimeouttimer);
			setSessionalreadywarn(false);
			setSessionTimeStart();
			return;
		}

		setSessionTimeStart(new Date());
	},[uISSessionaktif]);//-*/
	React.useEffect(() => {
		//console.log("(App - [uSessionTimeStart]) uSessionTimeStart => "+uSessionTimeStart);
		if(!uSessionTimeStart) return;
		
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			prosesSessioncount();
		},1000)
	},[uSessionTimeStart]);//-*/
	React.useEffect(() => {
		if(uCoundownsession > 35) { 
			setSessionalreadywarn(false);
			setDlgsessionshow(false); 
		}
		if(!uISSessionaktif) return;

		//console.log("(App - [uCoundownsession]) uISSessionalreadywarn => "+uISSessionalreadywarn);
		
		if((uCoundownsession <= 35 && uCoundownsession >= 0) 
			&& !uIsDlgsessionshow
			&& !uISSessionalreadywarn
			) {
			setDlgsessionshow(true);
		}

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout);
			prosesSessioncount();
		},1000); 
	},[uCoundownsession]);//-*/
	React.useEffect(() => {
		if(!uKlikDlgsessionYA) return;
		setKlikDlgsessionYA(false);

		apiProsessession();
	},[uKlikDlgsessionYA]);
	React.useEffect(() => {
		if(!uIsDlgsessionshow) return;
		
		setSessionalreadywarn(true);
	},[uIsDlgsessionshow]);
	React.useEffect(() => {
		if(!uActiveRoute || uActiveRoute==="" || !token) {
			setPagerouteactiveArr([]);
			return;
		}

		const buildRoutes = async () => {
			const builtRoutes = await Promise.all(
				uDetilPageArr
					.filter(vItems=>(vItems.owner||"").toUpperCase() === (uActiveRoute||"").toUpperCase())
					.map(vItems=>{
						try {
							const vName = vItems.name.charAt(0).toUpperCase() + vItems.name.slice(1);
							const TheComponent = React.lazy(()=>import(`./pages/detil/${vName}`));
							if(!TheComponent) return null;

							return {
								path: (vItems.path || "").toLowerCase(),
								element: (
									<Suspense fallback={<MyLoader show={true}/>}>
									<TheComponent
										setToken={setToken}
										showToast={showToast}
										setLoading={setLoading}
										prosesExpired={prosesExpired}
										clearStorage={clearStorage}
										setSessionaktif={setSessionaktif}
										{...props}/>
									</Suspense>
								)//>
							};
						} catch (err) {
							console.error("Failed to load module", err);
							return null;
						}
					})
			);

			const vPageactiveArr = builtRoutes.filter(route => route !== null);
			setPagerouteactiveArr(vPageactiveArr);
		}

		buildRoutes();
	},[uActiveRoute]);//-*/
	React.useEffect(() => {
		//console.log("(App - [uRouteISrefresh]) uRouteISrefresh",(uRouteISrefresh))

		if(!uRouteISrefresh) return;
		uDispatch({type: "set", gRouteISrefresh: false});

		//console.log("(App - [uRouteISrefresh]) uRoutesloadArr",JSON.stringify(uRoutesloadArr))
		//console.log("(App - [uRouteISrefresh]) token",JSON.stringify(token))

		setRoutescontentArr(uRoutesloadArr);
	},[uRouteISrefresh]);//-*/
	React.useEffect(() => {
		/*if(!token) {
			setLayoutchildrenArr([]);
			return;
		}//-*/
		const buildRoutes = async () => {
			if(uRoutescontentArr.length <= 0) {
				setLayoutchildrenArr([]);
				return;
			}

			const builtRoutes = await Promise.all(
				uRoutescontentArr.map(async (vItems) => {
					try {
						const TheComponent = staticRoutes[vItems.name.charAt(0).toUpperCase() + vItems.name.slice(1)];
						
						if(!TheComponent) return null;

						return {
							index: (vItems.name || "").toUpperCase() === "DASHBOARD",
							path: (vItems.path || "").toLowerCase(),
							element: (
								<Suspense fallback={<ContentSpinner/>}>
								<TheComponent
									setToken={setToken}
									showToast={showToast}
									setLoading={setLoading}
									prosesExpired={prosesExpired}
									clearStorage={clearStorage}
									setSessionaktif={setSessionaktif}
									{...props}/>
								</Suspense>
							)//>
						};
					} catch (err) {
						console.error("Failed to load module", err);
						return null;
					}
				})
			);

			const vLayoutchildrenArr = builtRoutes.filter(route => route !== null);

			//console.log("uRoutescontentArr => ",uRoutescontentArr);
			//console.log("vLayoutchildrenArr => ",vLayoutchildrenArr);

			//const Error404 	= React.lazy(() => import('./views/Error404'));
			const TheComponent = staticRoutes["Error404"];
			const errorRoutes = [
				{ index: false, path: "/error404", element: (
					<TheComponent
						setToken={setToken}
						showToast={showToast}
						setLoading={setLoading}
						prosesExpired={prosesExpired}
						clearStorage={clearStorage}
						setSessionaktif={setSessionaktif}
						{...props}/>
					)},
				{ index: false, path: "*", element: (
					<TheComponent {...props}/>
					)}
			];

			setLayoutchildrenArr([...vLayoutchildrenArr,...errorRoutes]);
		};
		buildRoutes();
	},[uRoutescontentArr]);
	React.useEffect(() => {
		if(!token) return;

		apiProseslokasi();
	},[uGeolocationStr]);
	React.useEffect(() => {
		//console.log("(App - [uErrorlokasimsg]) uErrorlokasimsg : ",uErrorlokasimsg);
		//if(!token) return;
		if(!uErrorlokasimsg) return;

		uDispatch({type: "set", locationError: undefined});
		showToast(uErrorlokasimsg);
	},[uErrorlokasimsg]);
	React.useEffect(() => {
		//console.log("(App - [uToasteraddObj]) uToasteraddObj : ",JSON.stringify(uToasteraddObj));
		if(!uToasteraddObj) return;
		setToasteraddObj();

		uDispatch({type: "set", listToast: [...uToastlistArr, uToasteraddObj ]});
	},[uToasteraddObj]);//-*/
	/*React.useEffect(() => {
		console.log("(App - [uToastlistArr]) uToastlistArr : ",JSON.stringify(uToastlistArr));
	},[uToastlistArr]);//-*/
	//---END EFFECT--/

	let uBrowserrouterINIT;//	= createBrowserRouter(uBrowserrouterArr);

	//console.log("(App) uToastlistArr",(uToastlistArr))

	//---FIRSTLOADING--/
	if(isApploading) return (<MyLoader isShow={isApploading}/>)//>
	//---END FIRSTLOADING--/

	//--IF_GEO_LOCATION_NOT_SUPPORTED--/
	if(!navigator.geolocation) {
		uBrowserrouterINIT = createBrowserRouter([
			{path:"/*", element: (<Navigate from="/" to="/error500"/>) },
			{path:"/error500", element:(<Error500 showToast={showToast} setLoading={setLoading} {...props}/>)},
		])

		return (
		<RouterProvider router={uBrowserrouterINIT}/>
		)//>
	}
	//--END IF_GEO_LOCATION_NOT_SUPPORTED--/

	//---JIKA_INTERNET_PROBLEMS--/
	if(!isInitKoneksi)  {
		uBrowserrouterINIT = createBrowserRouter([
			{path:"/*", element: (<Navigate from="/" to="/error500"/>) },
			{path:"/error500", element:(<Error500 showToast={showToast} setLoading={setLoading} {...props}/>)},
		])

		return (
		<RouterProvider router={uBrowserrouterINIT}/>
		)//>
	}
	//---END JIKA_INTERNET_PROBLEMS--*/

	//---NO_TOKEN_AUTH--/
	if(!token) {
		uBrowserrouterINIT = createBrowserRouter([
				{path:"*", element:(<Navigate from="/" to="/login"/>) },
				//{path:"/error500", element:(<Error500 showToast={showToast} setLoading={setLoading} {...props}/>)},
				{path:"/login", element:(<Login 
					setToken={setToken}
					showToast={showToast}
					setLoading={setLoading}
					setSessionaktif={setSessionaktif}
					{...props}/>)},
				]);

		return (
		<>
		<MyLoader isShow={isLoading} />
		<MyToaster/>
		
		<ErrorBoundary FallbackComponent={(<div>Loading..</div>)}>
			<RouterProvider router={uBrowserrouterINIT}/>
		</ErrorBoundary>
		</>
		)//>
	}
	//---END NO_TOKEN_AUTH--*/

	//---WAITING--/
	if(uLayoutchildrenArr.length <= 0) return (<MyLoader isShow={isApploading}/>)//>
	//---END WAITING--/
	
	/*const loadDetilpage = (_MAINMENU) => {//--TIDAK_DIPAKAI--/
	 	if(_MAINMENU.toUpperCase() === ("pasien").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("jadwal").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("ongoing").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("kastransfer").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("kasselisih").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("ruparupa").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("omzetlain").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("biaya").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("belibarang").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("returbeli").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("konsinyasi").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("beliaset").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("hutangsupplier").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("hutangbeliaset").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("hutangjpl").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("hutanglain").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("hutangkonsi").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("tagihanpajak").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("kasbon").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("kasirtoko").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("copynota").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("titipandp").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("stokopname").toUpperCase()
	 		|| _MAINMENU.toUpperCase() === ("pecahstok").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("pakaiklinik").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("baranged").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("kasirklinik").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("payroll").toUpperCase() 
	 		|| _MAINMENU.toUpperCase() === ("user").toUpperCase() 
	 	) {
	 		return uDetilPageArr.map((vItem,vKey)=>{
				const {path,name,owner} = vItem;

				const vDetilname = name.toLowerCase();
				if(owner.toUpperCase() === _MAINMENU.toUpperCase()) {
					let KomponenDetil;
					try {
						KomponenDetil = require("./pages/detil/"+UFunc.capitalize(vDetilname)).default;
					} catch (ex) {
						//console.log("(App - loadDetilpage) uDetilPageArr.name(ex) = ./detil/"+vDetilname);
					}
					return KomponenDetil && (
						<Route
							key={vKey}
							path={path}
							exact
							name={UFunc.capitalize(vDetilname)}
							element={
								<KomponenDetil
									setToken={setToken}
									showToast={showToast}
									setLoading={setLoading}
									prosesExpired={prosesExpired}
									clearStorage={clearStorage}
									setSessionaktif={setSessionaktif}
									{...props}/>
							}/>
					)	
				}
			})
	 	} 
	}//-*/

	uBrowserrouterINIT = createBrowserRouter([
		{path:"/", element: (<Navigate to="/dashboard" replace />) },
		{path:"/login", element: (<Navigate to="/dashboard"/>) },
		//{path:"/error500", element:(<Error500 showToast={showToast} setLoading={setLoading} {...props}/>)},
		{path:"/error500", element: (<Navigate to="/dashboard"/>) },
		{path:"/", name:"Layout", 
		    errorElement: (<ErrorBoundary FallbackComponent={(<Error500 {...props}/>)}/>),
			element:(
				<Layout
					setToken={setToken}
					showToast={showToast}
					setLoading={setLoading}
					prosesExpired={prosesExpired}
					clearStorage={clearStorage}
					setSessionaktif={setSessionaktif} 
					{...props}/>
			),//>
			children: uLayoutchildrenArr
		},
		{path:"/updatedlogs", name:"Updatedlogs", element:(<Updatedlogs
			setToken={setToken}
			showToast={showToast}
			setLoading={setLoading}
			prosesExpired={prosesExpired}
			clearStorage={clearStorage}
			setSessionaktif={setSessionaktif} 
			{...props}/>)},
		...uPagerouteactiveArr,
	]);//>

	return (
		<>
		<MyLoader isShow={isLoading} />
		<MyToaster/>
		
		<div style={{zIndex:2000}} className="d-none position-fixed bottom-0 start-0 p-2 text-danger">[{uCoundownsession}]</div>

		<ErrorBoundary FallbackComponent={(<Error500 {...props}/>)}>
		<RouterProvider router={uBrowserrouterINIT} fallbackElement={(<MyLoader isShow={true}/>)}/>
		</ErrorBoundary>

		{uIsTotopshow && (
		<div onClick={()=>hdlKlikToTop()} className="text-danger classToTop">
			<CIcon icon="cilArrowCircleTop" height={35}/>
		</div>
		)}

		<MyDialogsession
			onKlikyes={()=>hdlKlikDlgsessionYA()}
			show={uIsDlgsessionshow} 
			toggle={hdlToggleDlgsession} 
			Countertime={uCoundownsession}/>
		</>
    )//>
}

export default App
	